import React, { useEffect, useState } from 'react';
// import './ProviderList.scss';
import './TreasureHunt.scss'
import { makeStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import { Link, Tab, Tabs } from '@material-ui/core';
import { useNavigationService } from '../../fx-core';
import NewCamp from '../../New  Camp/NewCamp';
import ScheduleCamp from '../../ScheduleCamp/ScheduleCamp';
import CompletedCamp from '../../CompletedCamp/CompletedCamp';


const styles = makeStyles((theme) => ({
  drawerWidth: {
    [theme.breakpoints.down(599)]: {
      width: '90%',
    },
    [theme.breakpoints.up(600)]: {
      width: '70%',
    },
    [theme.breakpoints.up(1025)]: {
      width: '40%',
    },
  },

}));

const TreasureHunt = () => {
  const { routeData, back } = useNavigationService();
  const [value, setValue] = useState('newcampaign');
  const classes = styles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const navToBack = () => {
    back();
  };

  return (
    <div className="provider-list-ui pt-4 mt-3">
      <div className="title-font custom-head pl-4 pt-5">
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            color="primary"
            className="custom-link pointer breadcrumbs-style"
            onClick={navToBack}
          >
            <b>{routeData.communityName}</b>
          </Link>
          <Typography color="primary" className="breadcrumbs-style">
            Treasure Hunt
          </Typography>
        </Breadcrumbs>
      </div>
      <div className="MuiTabs-root" mt="3">
        <Tabs
          value={value}
          onChange={handleChange}
          // classes={{ indicator: classes.tabsIndicator }}
        >
          <Tab label="New Campaign" value="newcampaign" />
          <Tab label="Sceduled Campaign" value="scheduledcampaign" />
          <Tab label="Completed Campaign" value="completedcampaign" />
        </Tabs>
        </div>

        {
          <div className="tab-content">
              {value === 'newcampaign' && <NewCamp />}
        {value === 'scheduledcampaign' && <ScheduleCamp />}
        {value === 'completedcampaign' && <CompletedCamp />}
          </div>
        }

      
    </div>
  );
};
export default TreasureHunt;